import resume from '../assets/pdf/Mahmoud Emad Tonsy (FrontEnd Developer-Cv-2024).pdf'
import landingImg from "../assets/png/img.jpeg"
export const headerData = {
  name: "Mahmoud Tonsy",
  title: "Front End Developer",
  desciption:
    "The best way to predict the future is to invent it.",
  image: landingImg,
  resumePdf: resume,
};
